import * as sessionActions from '../actions/session';

const defaultState = {
    sessionUser: window.config.session_user,
    selectedLicence: null,
    isUpdatingLicence: false,
};

export default function (state = defaultState, action) {
    switch (action.type) {
        case sessionActions.SESSION_USER_UPDATED:
            return {
                ...state,
                sessionUser: action.user,
            };
        case sessionActions.SELECTED_LICENCE_REFRESHED:
            return {
                ...state,
                selectedLicence: action.selectedLicence,
            };
        case sessionActions.TOGGLE_UPDATING_LICENCE:
            return {
                ...state,
                isUpdatingLicence: action.isUpdatingLicence,
            };
        default:
            return state;
    }
}
